<template>
  <div
    class="main scroll"
    @click="cancelContent"
    @contextmenu.prevent="showBody($event, null)"
    ref="scroll"
  >
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            建立学生
          </div>
        </div>
        <div class="right">
          <div class="num">
            已建立本班学生<span class="blue">{{ studentList.length }}</span
            >名
          </div>
          <div class="msg">
            <div class="txt blue">学生信息</div>
            <a-icon :style="{color:'#898989'}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="student-list">
          <div v-if="userInfo && userInfo.relation_bind_type == 1" @click="showCreateModal" class="addbox">
            <div class="add blue">+</div>
            <div class="addtip">点击添加学生</div>
          </div>
          <div
            v-for="(item, index) in studentList"
            :key="index"
            @click.prevent="handleselectStudent(index, $event)"
            @contextmenu.prevent="show($event, index)"
            class="cell"
            :class="item.select ? 'select' : ''"
          >
            <a-upload
              name="file"
              class="avatar-uploader"
              :data="{related_path: 'avatar'}"
              :show-upload-list="false"
              :action="$api.domain2 + $api.uploadBigAvatar"
              @change="uploadChange"
            >
              <img
                @click="selectCurrentStudent(item.id)"
                class="tx"
                :src="
                  item.head_img
                    ? item.head_img
                    : require('../assets/upload-tx.png')
                "
                alt=""
              />
            </a-upload>
            <!-- <a-upload
              name="file"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="$api.domain + $api.addPhoto"
              @change="uploadChange"
            >
              <img
                @click="selectCurrentStudent(item.id)"
                class="tx"
                :src="
                  item.head_img
                    ? item.head_img
                    : require('../assets/upload-tx.png')
                "
                alt=""
              />
            </a-upload> -->
            <div class="msg">
              <div @click.stop="handleEditStudent(index)" class="top">
                <div class="name">{{ item.name }}</div>
                <img
                  class="edit"
                  :src="require('../assets/icon-10.png')"
                  alt=""
                />
              </div>
              <div class="foot" :class="item.parent ? 'hasbind' : ''">
                家长：{{ item.parent == 0 ? "未绑定" : "已绑定" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showRight" class="rightContent" :style="rightStyle">
        <div @click="showCreateModal" class="cell">添加学生</div>
        <div @click="editModal = true" v-show="selectStudent > -1" class="cell">
          修改姓名
        </div>
        <div @click="handleSelectAll" class="cell">选择全部</div>
        <div @click="delModal = true" class="cell">删除学生</div>
      </div>
      <a-modal :visible="createModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('@/assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">建立学生</div>
            <a-input
              v-model="studentName"
              placeholder="建立多个学生以一个空格隔开"
            />
            <div class="btns">
              <a-button @click="cacenlCreateStudent">取消</a-button>
              <a-button @click="createStudent" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="editModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('@/assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改学生姓名</div>
            <a-input
              v-model="editStudent.name"
              :placeholder="editStudent ? editStudent.name : ''"
            />
            <div class="btns">
              <a-button @click="editModal = false">取消</a-button>
              <a-button @click="editStudentApi" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="delModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('@/assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">
              删除此学生所有照片和成长册，不可恢复。是否继续？
            </div>
            <div class="btns">
              <a-button @click="delModal = false">取消</a-button>
              <a-button @click="handleDelStudent" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="uploadState" centered :footer="false" width="300px" :mask="true" :closable="false">
        <div class="uploadstate">
            <a-icon :type="uploadStateNum != 3 ? 'loading' : 'check'"></a-icon>
            {{uploadStateNum == 1 ? '头像上传中...' : uploadStateNum == 2 ? '头像识别中...':'上传成功'}}
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import { mingdaoKey,mdApi } from "../js/mingdao";
export default {
  data() {
    return {
      studentList: [],
      createModal: false,
      studentName: "",
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      selectStudent: -1,
      editStudent: { name: "" },
      editModal: false,
      delModal: false,
      editStudentId: "",
      uploadState:false,
      uploadStateNum:1,
      rightStyle: {
        left: 0,
        top: 0,
      },
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  methods: {
    selectCurrentStudent(id) {
      this.editStudentId = id;
    },
    getBigPhoto(id) {
      return new Promise((resolve,reject)=>{
        this.$axios({
            method: "GET",
            url: this.$api.domain2 + this.$api.getBigAvatar,
            // headers: { Authorization: this.$store.state.headers },
            params: {
              id: id
            },
          })
            .then((res) => {
              if (res.data.result && res.data.data.facephotos.length > 0) {
                resolve(res.data.data.facephotos[0])
              } else {
                reject()
              }
            })
            .catch(() => {
              this.$axios({
                method: 'post',
                url: mdApi.getList,
                data:{
                  ...mingdaoKey,
                  "worksheetId":"xmjk",
                  filters: [{
                    "controlId":"684a4caaf47ca1d634aff8e1",
                    "value":"成长册-人脸识别"
                  }]
                }
              }).then(res => {
                this.$axios({
                method: 'post',
                url: mdApi.update,
                data: {
                  ...mingdaoKey,
                  "worksheetId":"xmjk",
                  "triggerWorkflow":true,
                  rowId: res.data.data[0].rowId,
                  "controls": [{
                    "controlId":"684a4cf9f070e5c77837df4b",
                    "value":"运行故障"
                  }]
                }
              })
              }) 
              
              reject()
            });
      })
    },
    uploadChange(e) {
      var sid = this.editStudentId
      console.log(e)
      if (e.file && e.file.response) {
        if (e.file.response.result) {
          this.uploadState = true 
          this.uploadStateNum = 2 
          var m = 0 
          this.t = setInterval(()=>{
            m++
            this.getBigPhoto(e.file.response.data.id).then((url)=>{
              this.$axios({
                method: "POST",
                url: this.$api.domain + this.$api.editStudent,
                headers: { Authorization: this.$store.state.headers },
                data: {
                  id: sid,
                  head_img: url,
                },
              })
                .then((res) => {
                  this.$message.info(res.data.msg);
                  if (res.data.status == 200) {
                    this.delModal = false;
                    clearInterval(this.t)
                    this.getStudent();
                    this.uploadState =false 
                    this.uploadStateNum = 1
                  }
                })
                .catch(() => {
                  this.$axios({
                    method: 'post',
                    url: mdApi.getList,
                    data:{
                      ...mingdaoKey,
                      "worksheetId":"xmjk",
                      filters: [{
                        "controlId":"684a4caaf47ca1d634aff8e1",
                        "value":"成长册-人脸识别"
                      }]
                    }
                  }).then(res=> {
                    console.log(res)
                    const row = res.data.data.rows.filter(item => item['684a4caaf47ca1d634aff8e1'] == '成长册-人脸识别')
                    if (row.length > 0) {
                      this.$axios({
                        method: 'post',
                        url: mdApi.update,
                        data: {
                          ...mingdaoKey,
                      "worksheetId":"xmjk",
                      "triggerWorkflow":true,
                      rowId: row[0].rowid,
                      "controls": [{
                        "controlId":"684a4cf9f070e5c77837df4b",
                        "value":"运行故障"
                      }]
                    }
                  })
                }
              })
                  this.$message.error("网络或服务器未知错误");
                });
            }).catch(()=>{
              if (m > 10) {
                this.$message.error('照片识别超时，请选择清晰照片尝试')
                this.delModal = false;
                this.uploadState =false 
                this.uploadStateNum = 1
                clearInterval(this.t)
              }
            })
          },1000)
        }
      } else {
        this.uploadState = true 
        this.uploadStateNum = 1
      }
    },
    handleSelectAll() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    handleDelStudent() {
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.delStudent,
          headers: { Authorization: this.$store.state.headers },
          data: { ids: ids.join(",") },
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.delModal = false;
              this.getStudent();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何学生");
      }
    },
    handleEditStudent(index) {
      this.editModal = true;
      this.editStudent = _.cloneDeep(this.studentList[index]);
    },
    editStudentApi() {
      if (!this.editStudent) {
        this.$message.error("未填写任何姓名");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.editStudent,
          headers: { Authorization: this.$store.state.headers },
          data: { id: this.editStudent.id, name: this.editStudent.name },
        })
          .then((res) => {
            this.studentName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.editModal = false;
              this.getStudent();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    cancelContent() {
      this.showRight = false;
    },
    handleselectStudent(index, $event) {
      if ($event.shiftKey) {
        this.studentList = this.studentList.map((arr, arrIndex) => {
          arr.select = false;
          if (this.currentIndex >= index) {
            if (arrIndex >= index && arrIndex <= this.currentIndex) {
              arr.select = true;
            }
          } else {
            if (arrIndex <= index && arrIndex >= this.currentIndex) {
              arr.select = true;
            }
          }
          return arr;
        });
        this.currentIndex = index;
        return false;
      }
      if ($event.ctrlKey) {
        this.studentList[index].select = !this.studentList[index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        this.studentList = this.studentList.map((arr, index2) => {
          arr.select = false;
          if (index2 == index) {
            arr.select = true;
          }
          return arr;
        });
        this.currentIndex = index;
      }
    },
    show(e, index) {
      if (this.userInfo.relation_bind_type != 1) {
        return
      }
      e.stopPropagation();
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.selectStudent = index;
      this.editStudent = _.cloneDeep(this.studentList[index]);
      if (!this.studentList[index].select) {
        this.studentList = this.studentList.map((arr) => {
          arr.select = false;
          return arr;
        });
        this.studentList[index].select = true;
      }

      this.currentIndex = index;
    },
    showBody(e) {
      if (this.userInfo.relation_bind_type != 1) return
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.selectStudent = -1;
    },
    cacenlCreateStudent() {
      this.createModal = false;
    },
    showCreateModal() {
      this.createModal = true;
    },
    createStudent() {
      if (this.createState) return false
      if (!this.studentName) {
        this.$message.error("未填写任何姓名");
      } else {
        this.createState = true
        this.createModal = false;
        this.$message.loading({content:"创建中...",key:'creating'});
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.createStudent,
          headers: { Authorization: this.$store.state.headers },
          data: { name: this.studentName },
        })
          .then((res) => {
            this.studentName = "";
            this.createState = false
            this.$message.info({content:"创建成功",key:'creating'});
            if (res.data.status == 200) {
              this.getStudent();
            }
          })
          .catch(() => {
            this.createState = false
            this.$message.error({content:"创建失败，网络或服务错误",key:'creating'});
          });
      }
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.studentList = res.data.data.rows;
          } else {
            this.$message.error({content:res.data.message,key:"load"})
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
  },
  created() {
    
    if (this.$store.state.userInfo) {
      this.getStudent();
    }
  },
  watch: {
    $route() {
      this.getStudent();
    },
    userInfo(val) {
      if (val) {
        this.getStudent();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.uploadstate{
  color: #2f73da;
  text-align: center;
}
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addbox {
    width: 250px;
    height: 130px;
    background: #fff;
    border-radius: 0 20px 0 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 250px;
    height: 130px;
    background: #fff;
    border-radius: 0 20px 0 20px;
    display: flex;
    flex-direction: row;
    padding: 15px;
    align-items: center;
    margin-bottom: 30px;
    margin-right: 30px;
    box-sizing: border-box;
    .tx {
      width: 69px;
      height: 92px;
      margin-right: 20px;
      cursor: pointer;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      flex: 1 1 0%;
      height: 90px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .foot {
      color: #898989;
      &.hasbind {
        color: #67b0dc;
      }
    }
    .top {
      cursor: pointer;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 18px;
      img {
        width: 20px;
        margin-left: 10px;
      }
    }
  }
}
.rightContent {
  position: fixed;
  border-radius: 4px;
  background: #fff;
  width: 120px;
  padding: 10px 0;
  z-index: 10;
  box-shadow: 0 0 5px 2px rgba($color: #000000, $alpha: 0.08);
  .cell {
    width: 100%;
    line-height: 32px;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    &:hover {
      background: #67b0dc;
      color: #fff;
    }
  }
}
.main div,
.main span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
